import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { WorkflowFieldComponent } from '../workflow-field/workflow-field.component';
import { WorkflowConfigSection, WorkflowConfigStep } from '@monorepo/interfaces';
import { ProductTableComponent } from '../product-table/product-table.component';
import { SnowflakeSearchComponent } from '../snowflake-search/snowflake-search.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-workflow-step-fields',
    imports: [WorkflowFieldComponent, ProductTableComponent, SnowflakeSearchComponent, TranslatePipe],
    templateUrl: './workflow-step-fields.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowStepFieldsComponent {
    public readonly stepConfig = input.required<WorkflowConfigStep | WorkflowConfigSection>();
    public readonly stepForm = input.required<FormGroup>();
    public readonly disabled = input<boolean>(false);
    public readonly productsForm = input.required<FormGroup>();
    public readonly isSection = input.required<boolean>();
    public readonly isCreate = input<boolean>(false);

    protected readonly fieldControls = computed(() => this.extractFieldControls());

    protected readonly nonProductFields = computed(() =>
        (this.stepConfig().fields ?? []).filter(field => !field.productRelevant)
    );

    protected readonly productRelevantFields = computed(() =>
        (this.stepConfig().fields ?? []).filter(field => field.productRelevant)
    );

    private readonly snowflakeSectionName = 'section-snowflake-import';
    protected readonly isSnowflakeSection = computed(() => this.stepConfig().name === this.snowflakeSectionName);
    private extractFieldControls(): Record<string, FormControl> {
        const formGroup = this.stepForm();
        const fields = this.stepConfig().fields ?? [];

        return fields.reduce(
            (acc, field) => {
                const control = formGroup.get(field.name);
                if (control instanceof FormControl) {
                    acc[field.name] = control;
                }
                return acc;
            },
            {} as Record<string, FormControl>
        );
    }
}
